
import SIDEBARMENU from './SIDEBARMENU'

export default {
    'SIDEBARMENU': SIDEBARMENU
}